import BaseModule from './BaseModule'

class PublicModule extends BaseModule {
    constructor() {
        super()
    }

    // 提交意见反馈
    sendFeedback(params) {
        return this.post(`/api/feedback`, params)
    }
    // 提交意见反馈
    sendFeedback(params) {
        return this.post(`/api/feedback/add`, params)
    }

    // 获取表单中公共信息
    getPublicFormList() {
        return this.get(`/api/resource`)
    }
    // 获取当前账号基础信息
    getUserMsg() {
        return this.get(`/api/configuration/account`)
    }
    //获取省市静态资源
    getCity(){
        return this.get("https://static.ijiwei.com/city.json")
    }

    //获取热门城市
    getholCitys(){
        return this.get("/api/position/citylist")
    }

    //获取顶部广告
    getAdvertisement(){
        return this.get("/api/notice/title")
    }

    //获取广告详情
  getAdvertDetails(params) {
      return this.post(`/api/notice/title/info`, params, {
        headers: {
          "X-HTTP-Method-Override": "GET"
        }
      });
    }
}

export default new PublicModule()



// WEBPACK FOOTER //
// ./src/api/PublicModule.js